var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusyXs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    className: "busyXS",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "BUSY_main_transparent",
    d: "M20.6 6.6c2.8 1.8 4.6 4.9 4.6 8.5 0 5.6-4.5 10.1-10.1 10.1-4.9 0-9-3.5-9.9-8.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyXs);
export default __webpack_public_path__ + "static/media/busyXS.cf078afad18497504568178d60a55b17.svg";
export { ForwardRef as ReactComponent };